<template>
  <div class="row">
    <div class="col-sm-6">
      <SmsForm />
    </div>
    <div class="col-sm-6">
      <SmsPreview />
    </div>
  </div>
</template>

<script>
import SmsForm from "./components/SmsForm.vue";
import SmsPreview from "./components/SmsPreview.vue";
export default {
  components: {
    SmsForm,
    SmsPreview
  },
  data() {
    return {};
  }
};
</script>
